// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Management - Premium Dark Theme */
.user-management-container {
  width: 100%;
  padding: 0 16px;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Loading Overlay */
.um-loading-overlay {
  position: fixed;
  top: 0;
  left: 200px;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 27, 35, 0.85);
  z-index: 9999;
  backdrop-filter: blur(4px);
}

@media (max-width: 768px) {
  .um-loading-overlay {
    left: 0;
  }
}

/* Header */
.um-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.um-add-btn {
  background: linear-gradient(135deg, #2873ff 0%, #2060e0 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(40, 115, 255, 0.25);
}

.um-add-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(40, 115, 255, 0.35);
}

/* ===== TABLE ===== */
.um-table-container {
  flex: 1 1;
  overflow-x: auto;
  background: #22232b;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.um-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.um-table thead {
  background: #282930;
  position: sticky;
  top: 0;
}

.um-table th {
  padding: 14px 16px;
  text-align: left;
  color: #94a3b8;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.um-table td {
  padding: 14px 16px;
  color: #cbd5e1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.um-table tbody tr {
  transition: background 0.15s ease;
  background: #1e1f27;
}

.um-table tbody tr:nth-child(even) {
  background: #22232b;
}

.um-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}

.um-username {
  font-weight: 600;
  color: #e2e8f0;
}

/* ===== ROLE BADGE ===== */
.um-role-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.um-role-badge.role-app-manager {
  background: rgba(139, 92, 246, 0.15);
  color: #a78bfa;
  border: 1px solid rgba(139, 92, 246, 0.25);
}

.um-role-badge.role-admin {
  background: rgba(40, 115, 255, 0.15);
  color: #60a5fa;
  border: 1px solid rgba(40, 115, 255, 0.25);
}

.um-role-badge.role-user {
  background: rgba(100, 116, 139, 0.15);
  color: #94a3b8;
  border: 1px solid rgba(100, 116, 139, 0.2);
}

/* ===== STATUS BADGE ===== */
.um-status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.um-status.active {
  background: rgba(74, 222, 128, 0.12);
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.2);
}

.um-status.inactive {
  background: rgba(248, 113, 113, 0.1);
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.2);
}

/* ===== ACTION BUTTONS ===== */
.um-actions {
  display: flex;
  gap: 8px;
}

.um-action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.um-action-btn svg {
  width: 16px;
  height: 16px;
}

.um-action-btn.edit {
  background: rgba(40, 115, 255, 0.1);
  color: #60a5fa;
  border: 1px solid rgba(40, 115, 255, 0.2);
}

.um-action-btn.edit:hover {
  background: rgba(40, 115, 255, 0.2);
  border-color: rgba(40, 115, 255, 0.3);
}

.um-action-btn.delete {
  background: rgba(248, 113, 113, 0.08);
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.15);
}

.um-action-btn.delete:hover {
  background: rgba(248, 113, 113, 0.15);
  border-color: rgba(248, 113, 113, 0.25);
}

/* ===== MODAL INPUT GROUP ===== */
.modal-input-group {
  margin-bottom: 16px;
}

.modal-input-group label {
  display: block;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.modal-input-group input,
.modal-input-group select {
  width: 100%;
  padding: 12px 16px;
  background: #1a1b23;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #e2e8f0;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: all 0.2s ease;
}

.modal-input-group input:focus,
.modal-input-group select:focus {
  border-color: rgba(40, 115, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(40, 115, 255, 0.1);
}

.modal-input-group input::placeholder {
  color: #64748b;
}

.modal-input-group select {
  cursor: pointer;
}

/* Password wrapper */
.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-wrapper input {
  width: 100%;
  padding-right: 44px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.password-toggle:hover {
  color: #94a3b8;
}

.modal-input-group select option {
  background: #22232b;
  color: #e2e8f0;
}

/* ===== TOAST ===== */
.um-toast-container {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  max-width: 320px;
}

.toast.error {
  background: #2a2b35;
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.toast.success {
  background: #2a2b35;
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.2);
}

.toast .toast-message {
  flex: 1 1;
}

.toast .toast-action {
  padding: 4px 10px;
  background: rgba(239, 68, 68, 0.08);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  font-family: inherit;
}

.toast .toast-close {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
}

/* ===== MODAL ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: #22232b;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: 90%;
  max-width: 450px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: modal-appear 0.2s ease;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h3 {
  margin: 0;
  color: #e2e8f0;
  font-size: 16px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  color: #64748b;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
}

.modal-close:hover {
  color: #94a3b8;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin: 0;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.5;
}

.modal-error {
  color: #fb7185;
  font-size: 13px;
  margin-top: 12px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-btn.cancel {
  background: rgba(255, 255, 255, 0.06);
  color: #94a3b8;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-btn.cancel:hover {
  background: rgba(255, 255, 255, 0.1);
}

.modal-btn.confirm {
  background: #2873ff;
  color: #ffffff;
  border: 1px solid #2873ff;
}

.modal-btn.confirm:hover:not(:disabled) {
  background: #2060e0;
}

.modal-btn.danger {
  background: #ef4444;
  color: #ffffff;
  border: 1px solid #ef4444;
}

.modal-btn.danger:hover:not(:disabled) {
  background: #dc2626;
}

.modal-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .um-table {
    font-size: 12px;
  }

  .um-table th,
  .um-table td {
    padding: 10px 12px;
  }

  .um-add-btn {
    padding: 8px 16px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManagement.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* User Management - Premium Dark Theme */\n.user-management-container {\n  width: 100%;\n  padding: 0 16px;\n  position: relative;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Loading Overlay */\n.um-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 200px;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 27, 35, 0.85);\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n}\n\n@media (max-width: 768px) {\n  .um-loading-overlay {\n    left: 0;\n  }\n}\n\n/* Header */\n.um-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.um-add-btn {\n  background: linear-gradient(135deg, #2873ff 0%, #2060e0 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  font-family: inherit;\n  box-shadow: 0 2px 8px rgba(40, 115, 255, 0.25);\n}\n\n.um-add-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(40, 115, 255, 0.35);\n}\n\n/* ===== TABLE ===== */\n.um-table-container {\n  flex: 1;\n  overflow-x: auto;\n  background: #22232b;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.um-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.um-table thead {\n  background: #282930;\n  position: sticky;\n  top: 0;\n}\n\n.um-table th {\n  padding: 14px 16px;\n  text-align: left;\n  color: #94a3b8;\n  font-weight: 700;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.um-table td {\n  padding: 14px 16px;\n  color: #cbd5e1;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.um-table tbody tr {\n  transition: background 0.15s ease;\n  background: #1e1f27;\n}\n\n.um-table tbody tr:nth-child(even) {\n  background: #22232b;\n}\n\n.um-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.um-username {\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n/* ===== ROLE BADGE ===== */\n.um-role-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.um-role-badge.role-app-manager {\n  background: rgba(139, 92, 246, 0.15);\n  color: #a78bfa;\n  border: 1px solid rgba(139, 92, 246, 0.25);\n}\n\n.um-role-badge.role-admin {\n  background: rgba(40, 115, 255, 0.15);\n  color: #60a5fa;\n  border: 1px solid rgba(40, 115, 255, 0.25);\n}\n\n.um-role-badge.role-user {\n  background: rgba(100, 116, 139, 0.15);\n  color: #94a3b8;\n  border: 1px solid rgba(100, 116, 139, 0.2);\n}\n\n/* ===== STATUS BADGE ===== */\n.um-status {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.um-status.active {\n  background: rgba(74, 222, 128, 0.12);\n  color: #4ade80;\n  border: 1px solid rgba(74, 222, 128, 0.2);\n}\n\n.um-status.inactive {\n  background: rgba(248, 113, 113, 0.1);\n  color: #f87171;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n/* ===== ACTION BUTTONS ===== */\n.um-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.um-action-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.um-action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.um-action-btn.edit {\n  background: rgba(40, 115, 255, 0.1);\n  color: #60a5fa;\n  border: 1px solid rgba(40, 115, 255, 0.2);\n}\n\n.um-action-btn.edit:hover {\n  background: rgba(40, 115, 255, 0.2);\n  border-color: rgba(40, 115, 255, 0.3);\n}\n\n.um-action-btn.delete {\n  background: rgba(248, 113, 113, 0.08);\n  color: #f87171;\n  border: 1px solid rgba(248, 113, 113, 0.15);\n}\n\n.um-action-btn.delete:hover {\n  background: rgba(248, 113, 113, 0.15);\n  border-color: rgba(248, 113, 113, 0.25);\n}\n\n/* ===== MODAL INPUT GROUP ===== */\n.modal-input-group {\n  margin-bottom: 16px;\n}\n\n.modal-input-group label {\n  display: block;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.modal-input-group input,\n.modal-input-group select {\n  width: 100%;\n  padding: 12px 16px;\n  background: #1a1b23;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #e2e8f0;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.modal-input-group input:focus,\n.modal-input-group select:focus {\n  border-color: rgba(40, 115, 255, 0.5);\n  box-shadow: 0 0 0 3px rgba(40, 115, 255, 0.1);\n}\n\n.modal-input-group input::placeholder {\n  color: #64748b;\n}\n\n.modal-input-group select {\n  cursor: pointer;\n}\n\n/* Password wrapper */\n.password-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-wrapper input {\n  width: 100%;\n  padding-right: 44px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n}\n\n.password-toggle:hover {\n  color: #94a3b8;\n}\n\n.modal-input-group select option {\n  background: #22232b;\n  color: #e2e8f0;\n}\n\n/* ===== TOAST ===== */\n.um-toast-container {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  max-width: 320px;\n}\n\n.toast.error {\n  background: #2a2b35;\n  color: #f87171;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.toast.success {\n  background: #2a2b35;\n  color: #4ade80;\n  border: 1px solid rgba(74, 222, 128, 0.2);\n}\n\n.toast .toast-message {\n  flex: 1;\n}\n\n.toast .toast-action {\n  padding: 4px 10px;\n  background: rgba(239, 68, 68, 0.08);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.toast .toast-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 2px;\n  font-size: 14px;\n}\n\n/* ===== MODAL ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: #22232b;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  width: 90%;\n  max-width: 450px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  animation: modal-appear 0.2s ease;\n}\n\n@keyframes modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #e2e8f0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.modal-close:hover {\n  color: #94a3b8;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.modal-error {\n  color: #fb7185;\n  font-size: 13px;\n  margin-top: 12px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.modal-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modal-btn.cancel {\n  background: rgba(255, 255, 255, 0.06);\n  color: #94a3b8;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.modal-btn.cancel:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modal-btn.confirm {\n  background: #2873ff;\n  color: #ffffff;\n  border: 1px solid #2873ff;\n}\n\n.modal-btn.confirm:hover:not(:disabled) {\n  background: #2060e0;\n}\n\n.modal-btn.danger {\n  background: #ef4444;\n  color: #ffffff;\n  border: 1px solid #ef4444;\n}\n\n.modal-btn.danger:hover:not(:disabled) {\n  background: #dc2626;\n}\n\n.modal-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .um-table {\n    font-size: 12px;\n  }\n\n  .um-table th,\n  .um-table td {\n    padding: 10px 12px;\n  }\n\n  .um-add-btn {\n    padding: 8px 16px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
